import React from 'react';
import { TopBar } from './src/components/TopBar';
import { HeroSection } from './src/components/HeroSection';
import { MultiStepForm } from './src/components/MultiStepForm';
import { LegalFooter } from './src/components/LegalFooter';
export function App() {
  return <div className="min-h-screen bg-navy flex flex-col relative" data-id="element-0">
      <TopBar data-id="element-1" />
      <main className="flex-1" data-id="element-2">
        <HeroSection data-id="element-3" />
        <MultiStepForm data-id="element-4" />
      </main>
      <LegalFooter data-id="element-5" />
    </div>;
}